export default __webpack_public_path__ + "static/media/searcher.920cc2ba.png";